console.log('url:',process.env.VUE_APP_API_BASE_URL)
const common={
	// 开发环境
	// url:'/apifuture',

	// 测试环境
	// url:'http://test.xin.bapi.zhongfuyun.com/index.php',

	// 生产环境
	// url:'https://api.zhongfuyun.com/index.php',

	url: process.env.VUE_APP_API_BASE_URL,
	openLoading:function(){//开启loading
		var loadBox=document.getElementsByClassName('loadBox')[0];
		loadBox.style.width=document.documentElement.clientWidth+'px';
		loadBox.style.height=document.body.offsetHeight+'px';
		loadBox.style.minHeight=document.documentElement.clientHeight+'px';
	},
	closeLoading:function(){//关闭loading
		var pageBody=document.getElementsByClassName('pageBody')[0];
		var loadBox=document.getElementsByClassName('loadBox')[0];
		loadBox.style.width = 0;
		loadBox.style.height = 0;
		loadBox.style.minHeight = 0;
	}

};

export{common};



//////////////////
// WEBPACK FOOTER
// ./static/tool.js
// module id = 0o0z
// module chunks = 1 2